import React, { FC, useReducer } from 'react';
import { GlobalStateContext, initialState, reducer } from './GlobalStateContext';

const GlobalStateProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <GlobalStateContext.Provider value={{ state, dispatch }}>{children}</GlobalStateContext.Provider>;
};

export default GlobalStateProvider;
